'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var performanceNow = {exports: {}};

exports.performanceNow = performanceNow;
